/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteContactCtrl',["$scope","$rootScope","$timeout","CategoryData", function($scope,$rootScope,$timeout,CategoryData)
    {
        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)// && !$scope.ad.view.currentCategoryView)
            {

                if ($scope.ad.appAttributes.displayFacebook)
                    $timeout(function() {
                        if (window.FB) {
                            window.FB.XFBML.parse();
                        }
                    },200);
            }
        });
    }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteContactCtrl.js